export const EDITABLE_ITEMS_STYLE = {
  padding: 5,
  height: '28px',
  display: 'flex',
  alignItems: 'center',
};
